import { inject, Injectable } from "@angular/core";
import { ConfigService } from "./config.service";

@Injectable()
export class StorageService{
    
    constructor(public configService: ConfigService) {

    }

    setItem(key: string, value: string) {
        localStorage.setItem(this.configService.config.sessionGroupCode + key, value);
    }

    getItem(key: string): string {
        return localStorage.getItem(ConfigService.SessionGroupCode + key) ?? '';
    }

    removeItem(key: string) {
        localStorage.removeItem(this.configService.config.sessionGroupCode + key);
    }

    clearAll() {
        localStorage.clear();
    }
}